import { ProjectTenderDto } from "./projectTypes";

/** Frontend types for the Lead resource. */

export enum ProjectLeadStatus {
  Lead = "Lead",
  Discarded = "LeadVerworfen",
  Converted = "Ausgeschrieben",
}

export type CreateProjectLeadDto = {
  projectName: string;
  situation: string | null;
  timeframe: string | null;
  revenue: string | null;
  customer: string | null;
};

export type UpdateProjectLeadDto = CreateProjectLeadDto;

export type ProjectLeadDto = {
  leadId: number;
  status: ProjectLeadStatus;
  projectName: string;
  situation: string | null;
  timeframe: string | null;
  revenue: string | null;
  customer: string | null;
  discardReason: string | null;
  creatorId: number;
  creatorName: string | null;
  createdAt: Date;
  projectId: number | null;
};

export type DiscardProjectLeadDto = {
  reason: string;
};

export type ConvertProjectLeadDto = {
  project: ProjectTenderDto;
};
